import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CampaignList from './Campaigns/CampaignList';
import Campaign from './Campaigns/Campaign';

function CampaignsRouter() {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={`${path}/campaigns`}>
                <CampaignList />
            </Route>
            <Route path={`${path}/campaigns/:campaignId`}>
                <Campaign />
            </Route>
            <Route default>
                <CampaignList />
            </Route>
        </Switch>
    );
}

export default CampaignsRouter;
